// extracted by mini-css-extract-plugin
export default {"topBtn":"style_topBtn__uCKVu","arrow":"style_arrow__s3V7r"};